import { useLoaderData, useLocation } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { type loader } from '#app/routes/_public+/products+/$slug'
import CategorySelectorClerkV2 from './clerk-components/clerk-category-selector-v2'

const ProductsListHeader = () => {
	const location = useLocation()
	const { categoriesData } = useLoaderData<typeof loader>()

	const pathParts = location.pathname.split('/')
	const categoryKey = pathParts[2] || ''
	const { t } = useTranslation('product_list_page')
	const currentCategory = categoriesData.result.find(
		(category: any) => category.id === categoryKey,
	)
	const subCategories = currentCategory
		? categoriesData.result.filter((category: any) =>
				currentCategory.subcategories.includes(category.id),
		  )
		: []

	return (
		<>
			{currentCategory ? (
				<CategorySelectorClerkV2
					category={currentCategory}
					subCategories={subCategories}
					allCategories={categoriesData.result} // Pass all categories data here
					showMainCategory={false}
				/>
			) : (
				<div>{t('category_not_found')}</div>
			)}
		</>
	)
}

export default ProductsListHeader
